import { render, staticRenderFns } from "./ErrorBucket.vue?vue&type=template&id=55ccccd4&scoped=true&"
import script from "./ErrorBucket.vue?vue&type=script&lang=js&"
export * from "./ErrorBucket.vue?vue&type=script&lang=js&"
import style0 from "./ErrorBucket.vue?vue&type=style&index=0&id=55ccccd4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55ccccd4",
  null
  
)

export default component.exports